export const RAISE_REASONS = [
  { code: "po_contract", label: "Fulfill a purchase order or contract", category: "PO / Invoice Financing" },
  { code: "inventory", label: "Purchase stock or inventory", category: "Inventory / Trade Finance" },
  { code: "assets", label: "Buy equipment, machinery, or vehicles", category: "Asset Financing" },
  { code: "expansion", label: "Expand the business (new location, market, capacity)", category: "Growth Capital / Equity" },
  { code: "new_product", label: "Launch a new product or project", category: "Venture / Project Finance" },
  { code: "working_capital", label: "Working capital (operations, marketing, payroll)", category: "Working Capital" },
  { code: "refinance_debt", label: "Refinance or consolidate existing debt", category: "Debt Refinancing" },
  { code: "other", label: "Other", category: "" },
];
